export default {"src":"/_next/static/media/email.9bb89560.svg","height":19,"width":29,"blurWidth":0,"blurHeight":0};